import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'thaidate'
})
export class ThaiDatePipe implements PipeTransform {

    transform(date: Date, format: string): string {
        console.log('date',date,'format',format)
        let ThaiDay = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']
        let shortThaiMonth = [
            'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
            'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
        ];
        let longThaiMonth = [
            'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
            'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
        ];
        let inputDate = new Date(date);
        let dataDate = [
            inputDate.getDay(), inputDate.getDate(), inputDate.getMonth(), inputDate.getFullYear()
        ];
        let time = inputDate.getHours() + ":" + (inputDate.getMinutes()<10?'0':'') + inputDate.getMinutes() 
        let dataDateTime:any = [
            inputDate.getDay(), inputDate.getDate(), inputDate.getMonth(), inputDate.getFullYear(),time
        ];
        let dataDateTimeClock:any = [
            inputDate.getDay(), inputDate.getDate(), inputDate.getMonth(), inputDate.getFullYear(),"เวลา",time,"น."
        ];
        let dataDateTimeBEYear:any = [
            inputDate.getDay(), inputDate.getDate(), inputDate.getMonth(), inputDate.getFullYear(),"เวลา",time,"น."
        ];




        let outputDateFull = [
            'วัน ' + ThaiDay[dataDate[0]],
            'ที่ ' + dataDate[1],
            'เดือน ' + longThaiMonth[dataDate[2]],
            'พ.ศ. ' + (dataDate[3] + 543)
        ];
        let outputDateShort = [
            dataDate[1],
            shortThaiMonth[dataDate[2]],
            dataDate[3] + 543
        ];
        let outputDateMedium = [
            dataDate[1],
            longThaiMonth[dataDate[2]],
            dataDate[3] + 543
        ];
        let outputDateTime = [
            dataDateTime[1],
            longThaiMonth[dataDateTime[2]],
            dataDateTime[3] + 543,
            dataDateTime[4]

        ];
        let outputDateTimeclock = [
            dataDateTimeClock[1],
            shortThaiMonth[dataDateTimeClock[2]],
            dataDateTimeClock[3]+543,
            dataDateTimeClock[4],
            dataDateTimeClock[5],
            dataDateTimeClock[6]
        ];
        let outputFullDateTimeclock = [
            dataDateTimeClock[1],
            longThaiMonth[dataDateTimeClock[2]],
            dataDateTimeClock[3]+543,
            dataDateTimeClock[4],
            dataDateTimeClock[5],
            dataDateTimeClock[6]
        ];
        let outputDateTimeBEYear = [
            dataDateTimeBEYear[1],
            shortThaiMonth[dataDateTimeBEYear[2]],
            dataDateTimeBEYear[3],
            dataDateTimeBEYear[4],
            dataDateTimeBEYear[5],
            dataDateTimeBEYear[6]

        ];
        let outputMonthDateTimeclock = [
            dataDateTimeClock[1],
            longThaiMonth[dataDateTimeClock[2]],
            dataDateTimeClock[3] + 543,
            dataDateTimeClock[4],
            dataDateTimeClock[5],
            dataDateTimeClock[6]

        ];
        let returnDate: string;
        returnDate = outputDateMedium.join(" ");
        if (format == 'full') {
            returnDate = outputDateFull.join(" ");
        }
        if (format == 'medium') {
            returnDate = outputDateMedium.join(" ");
        }
        if (format == 'short') {
            returnDate = outputDateShort.join(" ");
        }
        if (format == 'datetime') {
            returnDate = outputDateTime.join(" ");
        }
        if (format == 'datetimeclock') {
            returnDate = outputDateTimeclock.join(" ");
        }
        if (format == 'fulldatetimeclock') {
            returnDate = outputFullDateTimeclock.join(" ");
        }
        if (format == 'datetimeclockBEyear') {
            returnDate = outputDateTimeBEYear.join(" ");
        }

        if(format == 'fullmonthdatetimeclock'){
            returnDate = outputMonthDateTimeclock.join(" ");
        }

        return returnDate;
    }
}